"use client";

import { CloseIcon } from "@/components/ui/atoms/icons";
import { QUALITY_LABEL, type ChordEntry } from "@/lib/music/chord-catalog";
import { useChordLabel } from "@/hooks/use-notation";
import { BORDER, FONT_MONO, TEXT, TEXT_DIM, TEXT_MUTE } from "./palette";

type Props = {
  entry: ChordEntry;
  onClose: () => void;
};

export function PedagogyPanelHeader({ entry, onClose }: Props) {
  const chordLabel = useChordLabel();

  return (
    <div
      style={{
        padding: "18px 22px 14px",
        borderBottom: `1px solid ${BORDER}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div
          style={{
            fontSize: 10,
            color: TEXT_MUTE,
            letterSpacing: "0.18em",
            fontWeight: 600,
            fontFamily: FONT_MONO,
            textTransform: "uppercase",
          }}
        >
          Décrypter
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 400,
            color: TEXT,
            marginTop: 4,
            letterSpacing: "-0.01em",
          }}
        >
          {chordLabel(entry.symbol)} ·{" "}
          {QUALITY_LABEL[entry.quality].toLowerCase()}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Fermer le panneau"
        style={{
          width: 28,
          height: 28,
          borderRadius: 6,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: TEXT_DIM,
          cursor: "pointer",
          background: "transparent",
          border: `1px solid ${BORDER}`,
        }}
      >
        <CloseIcon size={14} />
      </button>
    </div>
  );
}
